import type { TaskDetail, TrailerModel } from '@/service/types/movetasktypes';

// ─────────────────────────────────────────────────────────────────
// OIC → TrailerModel mapper
// ─────────────────────────────────────────────────────────────────

export interface OICTrailerDetail {
  Trailer_Name: string;
  Carrier_scac: string;
  Carrier_Name: string;
  Current_Location_Type: string;
  Current_Location_Zone: string;
  Current_Location_Name: string;
  Trailer_Comments: string;
  Trailer_id: number;
  Check_In_Time: string;
  Dwelling_Time: string;
  Trailer_Status: string;
  Pallets_Loaded: string;
  Shipment: string;
  Order: string;
  Scheduled_Pickup: string;
  Customer_Name: string;
  Item: string;
  Purchase_Order: string;
  Driver_Name: string;
  Driver_Cell: string;
  Dwelling_Time_Hours: string;
  Trailer_Condition: string;
  Lock_Reason_Code: string;
}

export function mapOICTrailer(raw: OICTrailerDetail): TrailerModel {
  return {
    Trailer_Name: raw.Trailer_Name,
    Carrier_Name: raw.Carrier_Name,
    Carrier_scac: raw.Carrier_scac,
    TrailerId: raw.Trailer_id,
    CurrentLocationType: raw.Current_Location_Type,
    CurrentLocationZone: raw.Current_Location_Zone,
    CurrentLocationName: raw.Current_Location_Name,
    Location: raw.Current_Location_Name,
    TrailerComments: raw.Trailer_Comments,
    CheckInTime: raw.Check_In_Time,
    DwellingTime: raw.Dwelling_Time,
    TrailerStatus: raw.Trailer_Status,
    PalletsLoaded: raw.Pallets_Loaded,
    Shipment: raw.Shipment,
    Order: raw.Order,
    ScheduledPickup: raw.Scheduled_Pickup,
    CustomerName: raw.Customer_Name,
    Item: raw.Item,
    PurchaseOrder: raw.Purchase_Order,
    DriverName: raw.Driver_Name,
    DriverCell: raw.Driver_Cell,
    DwellingTimeHours: raw.Dwelling_Time_Hours,
    TrailerCondition: raw.Trailer_Condition,
    LockReasonCode: raw.Lock_Reason_Code,
    TrailerStatusName: '',
    TrailerConditionName: '',
    IsEditing: false,
    IsTrailerDamaged: false,
    LockReasonCodeName: '',
  };
}

// ─────────────────────────────────────────────────────────────────
// OIC → TaskDetail mapper (preserves string Status for move task filtering)
// ─────────────────────────────────────────────────────────────────

export interface OICMoveTaskDetail {
  Task_id: string;
  Task_type: string;
  Status: string;
  Priority: string;
  Trailer_name: string;
  Trailer_id: string;
  Carrier_company_name: string;
  Carrier_name: string;
  Move_src_type: string;
  Move_src_zone: string;
  Move_src_name: string;
  Move_dst_type: string;
  Move_dst_zone: string;
  Move_dst_name: string;
  Audit_locn_type: string;
  Audit_locn_zone: string;
  Audit_locn_name: string;
  Created_datetime: string;
  Last_updated_datetime: string;
  Task_start_datetime: string;
  Task_end_datetime: string;
  Task_comments: string;
  Trailer_comments: string;
  Assigned_user_id: string;
  Exception_code: string;
  Elapsed_time: string;
  Alt_trailer_name: string;
  Alt_carrier: string;
  Alt_dst_zone: string;
  Alt_dst_name: string;
}

export function mapOICMoveTask(raw: OICMoveTaskDetail): TaskDetail {
  return {
    ActionCode: '',
    OrgId: '',
    TaskId: raw.Task_id,
    TaskType: raw.Task_type,
    Status: raw.Status,
    AssignedUserId: raw.Assigned_user_id,
    CreatedSource: '',
    CreatedDatetime: raw.Created_datetime,
    LastUpdatedDatetime: raw.Last_updated_datetime,
    LastUpdatedSource: '',
    Priority: raw.Priority,
    PriorityName: raw.Priority,
    YardId: '',
    TaskStartDateTime: raw.Task_start_datetime,
    TaskEndDateTime: raw.Task_end_datetime,
    TaskReleaseDatetime: '',
    TaskComments: raw.Task_comments,
    TrailerId: raw.Trailer_id,
    TrailerName: raw.Trailer_name,
    TrailerComments: raw.Trailer_comments,
    CarrierCompanyName: raw.Carrier_company_name,
    CarrierName: raw.Carrier_name,
    AuditLocationType: raw.Audit_locn_type,
    AuditLocationZone: raw.Audit_locn_zone,
    AuditLocationName: raw.Audit_locn_name,
    MoveSourceType: raw.Move_src_type,
    MoveSourceZone: raw.Move_src_zone,
    MoveSourceName: raw.Move_src_name,
    MoveDestinationType: raw.Move_dst_type,
    MoveDestinationZone: raw.Move_dst_zone,
    MoveDestinationName: raw.Move_dst_name,
    CurrentLoggedInUser: '',
    ElapsedTime: raw.Elapsed_time,
    ExceptionCode: raw.Exception_code,
    ExceptionText: '',
    TaskAssignedTime: '',
    AlternateTrailerValid: '',
    AlternateCarrier: raw.Alt_carrier,
    AlternateTrailerName: raw.Alt_trailer_name,
    AlternateDestinationZone: raw.Alt_dst_zone,
    AlternateDestinationName: raw.Alt_dst_name,
    TaskDescription: '',
  };
}
